import React from 'react';
import { Badge } from 'src/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { useTagName, TagBadge } from 'src/components/rebates/TagsDisplay';
import { CoreEnumOptionDTO } from 'src/api/core/core-enums/useCoreEnums';
import { CoreEnumOptionAssociation } from 'src/api/core/enumOptionAssociations/useEnumOptionAssociations';

interface RebateAgreementTagsPillProps {
  agreementId: string;
  tags: CoreEnumOptionAssociation[];
  availableTags: CoreEnumOptionDTO[];
}

interface TagNameDisplayProps {
  tag: CoreEnumOptionAssociation;
  availableTags: CoreEnumOptionDTO[];
}

function TagNameDisplay({ tag, availableTags }: TagNameDisplayProps) {
  const tagName = useTagName(tag, availableTags, 'Unknown');
  return <div className="text-xs">{tagName}</div>;
}

export function RebateAgreementTagsPill({
  agreementId,
  tags,
  availableTags,
}: RebateAgreementTagsPillProps) {
  if (tags.length === 0) {
    return <span className="text-xs text-muted-foreground">-</span>;
  }

  const displayTags = tags.slice(0, 2);
  const extraCount = tags.length - 2;

  return (
    <div className="flex flex-wrap gap-1 items-center">
      {displayTags.map((tag) => (
        <TagBadge
          key={tag.id}
          tag={tag}
          availableTags={availableTags}
          variant="secondary"
          size="sm"
          fallbackName="Unknown"
        />
      ))}
      {extraCount > 0 && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge variant="outline" className="text-xs cursor-help">
                +{extraCount}
              </Badge>
            </TooltipTrigger>
            <TooltipContent side="top">
              <div className="space-y-1">
                {tags.slice(2).map((tag) => (
                  <TagNameDisplay
                    key={tag.id}
                    tag={tag}
                    availableTags={availableTags}
                  />
                ))}
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
